export default `.jp-RenderedImage {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}

#notebook-container {
  padding: 15px !important;
}
`;
